module.exports = __webpack_public_path__ + "static/img/img-aboutus-02.89b4d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-aboutus-02.png
// module id = i7f/
// module chunks = 1